import * as React from 'react';
import { useContext } from 'react';
import styled from '@emotion/styled';
import { InnovidHeader } from './InnovidHeader';
import { UnitHeader } from './UnitHeader';
import { DemoContext } from '../Demo';

export const Header: React.FunctionComponent<{}> = React.memo(
  () => {
    const { tagInfo } = useContext(DemoContext);
    return <HeaderContainer>
    <InnovidHeader />
    {tagInfo && <UnitHeader tagInfo={tagInfo}/>}
    </HeaderContainer>
  });


const HeaderContainer = styled.div`
  width: 100%;
  background-color: #000000;
  display: flex;
  flex-direction: column;
  align-items: center;
  user-select: none;
`;
